import {Typography, TypographyProps} from "@mui/material";
import {colors, textVariants} from "../theme";

export type TextVariant = keyof typeof textVariants;

type TextProps = Omit<TypographyProps, "variant"> & {
  variant?: TextVariant;
};

export const Text = ({variant = "body", color = colors.grey[800], sx, ...props}: TextProps) => (
  <Typography sx={{...textVariants[variant], color, ...sx}} {...props} />
);
